<template></template>

<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import Authentication from "@/components/Authentication.vue";
import { mapState, mapMutations } from "vuex";
import { API } from "aws-amplify";
export default {
  name: "Logoff",
  data() {
    return {};
  },
  computed: {
    ...mapState("user", ["confirmed", "user", "state", "sn"])
  },
  async created() {
    await this.logout();
    this.$router.push("/");
  },
  methods: {
    ...mapMutations("user", [
      "emptyUser",
      "unsetConfirmed",
      "setState",
      "setSN",
      "setSNAnswer",
      "setError",
      "setLoading",
      "setAnswer",
      "setPhones"
    ]),
    async logout() {
      await this.$Amplify.Auth.signOut();
      document.cookie = `ssoRequest=; expires=Thu, 01 Jan 1970 00:00:00 UTC`
      this.setSN(false);
      this.setSNAnswer(false);
      this.emptyUser();
      this.unsetConfirmed();
      this.setState("signedOut");
      this.setError(false);
      this.setLoading(false);
      this.setAnswer({});
      this.setPhones([]);
      this.$root.$emit("removeExtras");

      if (this.$route.query.post_logout_redirect_uri) {
        const data = await API.get('myAlerusIdentityBroker', '/oauth2/logoff', {
          queryStringParameters: this.$route.query
        })

        if (data && data.postLogoutUri) {
          window.location.href = data.postLogoutUri
        }
      }
    }
  }
};
</script>

<style lang="scss">
</style>
